module.exports = __webpack_public_path__ + "media/news/news-01-708b0be1.jpg";